import React, { useEffect } from 'react';
import {ChakraProvider, extendTheme} from '@chakra-ui/react';
import {Page} from './stories/Page';
import posthog from 'posthog-js';

function App() {
    useEffect(() => {
        // Initialize PostHog
        // Replace with your PostHog project API key
        posthog.init('phc_6MyVd97XqDysaXrPSJGWNo2wsJsK0jcoxeqvTKELytf', {
            api_host: 'https://us.i.posthog.com',
            loaded: (posthog) => {
                if (process.env.NODE_ENV === 'development') {
                    console.log('PostHog initialized');
                }
            },
            // Enable session recording
            session_recording: {
                recordCrossOriginIframes: true
            }
        });
    }, []);

    const customTheme = extendTheme({
        config: {
            initialColorMode: 'dark',
            useSystemColorMode: false,
        },
    });
    return (
        <ChakraProvider theme={customTheme}>
            <Page/>
        </ChakraProvider>
    );
}

export default App;
